$(function() {
  //six column slider
  var sixSlider = $(".js-six-sliders");    
  sixSlider.owlCarousel({
  loop: true,
  margin: 24,
  rtl: true,
  responsiveClass: true,
  autoWidth: false,
  dots: false,
      nav: true,
     // onTranslated: updateOpaqueItens,
  responsive: {
    0: {
      items: 1,
      nav: false,
      autoWidth: true,
      margin: 16,
    },
    768: {
      items: 4,
      autoWidth: false,
      margin:16,
    },
    1320: {
      items: 6,

    },
  },
  });

  //hotels slider
  var hotelSlider = $(".js-hotel-slider");

  hotelSlider.owlCarousel({
    loop: true,
    rtl: true,
    margin: 24,
    nav: true,
    dots: false,
    items: 4,
    responsive: {
      0: {
        items: 1,
        nav: false,
        autoWidth: true,
        margin: 12,
      },
      768: {
        items: 3,
        autoWidth: false,
      },
      1320: {
        items: 4,
        nav: true,
        margin: 24,
      },
        }
    });

   // init rating
  $(".getRating").giveScore({
    TotalNum: 5,
    getScore: false,
    setScore: true,
    fontIcon: true,
    htmlelement: false,
    writeScore: false,
    getAndSet: false,
    iclasses: {
      unselect: "icon-star--disabled",
      select: "icon-star",
      halfIcon: "icon-star--half"
    }
  });

  //toggle description
  if($('.js-description').height()>109){
    
    $('.js-toggle-description').show();
  }
  
  $('.js-toggle-description').click(function(){

    $(this).prev('.js-description-wrapper').toggleClass('description__wrapper--flexible');

    $(this).toggleClass('open');

    if($(this).prev('.js-description-wrapper').hasClass('description__wrapper--flexible')){

      $(this).children('span').text('کمتر')
     
    }else{

      $(this).children('span').text('بیشتر');
      
    }
  })

});
